import callAPI from "config/callAPI";
import PortalAuth from "config/auth/PortalAuth";
import { setPortalActiveMenu } from "libraries/common_functions";

import React from "react";

import PortalHeader from "pages/portal/includes/PortalHeader";
import PortalMobileMenu from "pages/portal/includes/PortalMobileMenu";
import PortalTopMenu from "pages/portal/includes/PortalTopMenu";
import PortalFooter from "pages/portal/includes/PortalFooter";

const ENDPOINT = process.env.REACT_APP_BACKEND_URL + '/portal_utilities';

class PortalHome extends React.Component {
    constructor(){
        super();
        this.state = {
            isloggedin: false,
            rstatsdata: [],
            rtopcampdata: [],
            rtopsourdata: []
        }

        console.log(this.state.isloggedin);
        let isloggedinPromise = PortalAuth();
        
        isloggedinPromise.then((isloggedin) => {
            this.setState({isloggedin: isloggedin});
            console.log(this.state.isloggedin);
        });
    }

    async getStats(){
        var data = {action: 'get_stats'};
        // eslint-disable-next-line
        var {rstatus, rmessage, rdata } = await callAPI(ENDPOINT, data);
        this.setState({
            rstatsdata: rdata
        });

        data = {action: 'get_top_campaigns'};
        // eslint-disable-next-line
        var {rstatus, rmessage, rdata } = await callAPI(ENDPOINT, data); 
        this.setState({
            rtopcampdata: rdata.top_campaigns_data
        });

        data = {action: 'get_top_sources'};
        // eslint-disable-next-line
        var {rstatus, rmessage, rdata } = await callAPI(ENDPOINT, data);
        this.setState({
            rtopsourdata: rdata.top_sources_data
        });

    }

    componentDidMount(){
        setPortalActiveMenu('dashboard');
        this.getStats();
    }

    render() {
        if (!this.state.isloggedin){
            return (<></>);
        }

        return (
            <>
                <PortalMobileMenu />

                <div className="flex">
                    
                    <PortalHeader />
                        
                    <div className="content">
                            
                        <PortalTopMenu page_name="Dashboard" />

                        <div className="grid grid-cols-12 gap-6">
                            <div className="col-span-12 xxl:col-span-9 grid grid-cols-12 gap-6">

                                <div className="col-span-12 mt-8">
                                    <div className="intro-y flex items-center h-10">
                                        <h2 className="text-lg font-medium truncate mr-5">
                                            Reports & Statistics
                                        </h2>
                                        <a href="/portal/home" className="ml-auto flex text-theme-1 dark:text-theme-10"> <i data-feather="refresh-ccw" className="w-4 h-4 mr-3"></i> Reload Data </a>
                                    </div>
                                    <div className="grid grid-cols-12 gap-6 mt-5">
                                        <div className="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
                                            <div className="report-box zoom-in">
                                                <div className="box p-5">
                                                    <div className="flex">
                                                        <i data-feather="monitor" className="report-box__icon text-theme-12"></i> 
                                                        <div className="ml-auto">
                                                            <div className="report-box__indicator bg-theme-9 tooltip cursor-pointer" title="Campaigns"> Campaigns <i data-feather="chevron-up" className="w-4 h-4"></i> </div>
                                                        </div>
                                                    </div>
                                                    <div className="text-3xl font-bold leading-8 mt-6">{this.state.rstatsdata.total_campaigns}</div>
                                                    <div className="text-base text-gray-600 mt-1">Total Campaigns</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-span-12 sm:col-span-6 xl:col-span-3 intro-y">
                                            <div className="report-box zoom-in">
                                                <div className="box p-5">
                                                    <div className="flex">
                                                        <i data-feather="user" className="report-box__icon text-theme-9"></i> 
                                                        <div className="ml-auto">
                                                            <div className="report-box__indicator bg-theme-9 tooltip cursor-pointer" title="Link Clicks"> Link Clicks <i data-feather="chevron-up" className="w-4 h-4"></i> </div>
                                                        </div>
                                                    </div>
                                                    <div className="text-3xl font-bold leading-8 mt-6">{this.state.rstatsdata.total_link_clicks}</div>
                                                    <div className="text-base text-gray-600 mt-1">Link Clicks</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-span-12 xl:col-span-4 md:col-span-4 sm:col-span-4 mt-6">
                                    <div className="intro-y block sm:flex items-center h-10">
                                        <h2 className="text-lg font-medium truncate mr-5">
                                            Top Campaigns
                                        </h2>
                                    </div>
                                    <div className="intro-y overflow-auto lg:overflow-visible mt-8 sm:mt-0">
                                        <table className="table table-report sm:mt-2">
                                            <thead>
                                                <tr>
                                                    <th className="whitespace-no-wrap">Campaign Name</th>
                                                    <th className="text-center whitespace-no-wrap">Link Clicks</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.rtopcampdata.length > 0 ?

                                                    this.state.rtopcampdata.map(function(campaign, i){
                                                        return(
                                                            <tr className="intro-x">
                                                                <td>
                                                                    <span className="font-medium whitespace-no-wrap">{campaign.campaign_name}</span> 
                                                                </td>
                                                                <td className="w-40">
                                                                    <div className="flex items-center justify-center text-theme-9"> <i data-feather="check-square" className="w-4 h-4 mr-2"></i> {campaign.link_clicks} </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })                                                    

                                                :

                                                    <tr className="intro-x">
                                                        <td>
                                                            <span className="font-medium whitespace-no-wrap">There is no data to show!</span> 
                                                        </td>
                                                    </tr>

                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="col-span-12 xl:col-span-4 md:col-span-4 sm:col-span-4 mt-6">
                                    <div className="intro-y block sm:flex items-center h-10">
                                        <h2 className="text-lg font-medium truncate mr-5">
                                            Top Sources
                                        </h2>
                                    </div>
                                    <div className="intro-y overflow-auto lg:overflow-visible mt-8 sm:mt-0">
                                        <table className="table table-report sm:mt-2">
                                            <thead>
                                                <tr>
                                                    <th className="whitespace-no-wrap">Source Name</th>
                                                    <th className="text-center whitespace-no-wrap">Link Clicks</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.rtopsourdata.length > 0 ?

                                                    this.state.rtopsourdata.map(function(source, i){
                                                        return(
                                                            <tr className="intro-x">
                                                                <td>
                                                                    <span className="font-medium whitespace-no-wrap">{source.utm_source.toUpperCase()}</span> 
                                                                </td>
                                                                <td className="w-40">
                                                                    <div className="flex items-center justify-center text-theme-9"> <i data-feather="check-square" className="w-4 h-4 mr-2"></i> {source.link_clicks} </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })                                                    

                                                :

                                                    <tr className="intro-x">
                                                        <td>
                                                            <span className="font-medium whitespace-no-wrap">There is no data to show!</span> 
                                                        </td>
                                                    </tr>

                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>
                        </div>


                        
                    </div>
                </div>

                <PortalFooter />
            </>
        );
    }
}

export default PortalHome;
